import React from "react";
import { Trans, WithTranslation } from "react-i18next";

const BrowseLink = (props: { onBrowse: () => void; children?: React.ReactNode }) => (
    <a onClick={props.onBrowse}>{props.children}</a>
);

type TranslationFn = WithTranslation["t"];

type Props = {
    t: TranslationFn;
    onBrowse: () => void;
};

export function CopySlideNoticeMessage({ t, onBrowse }: Props) {
    return (
        <Trans
            t={t}
            i18nKey="Search for the slide you need or <browseLink>browse</browseLink> your presentations."
            components={{ browseLink: <BrowseLink onBrowse={onBrowse} /> }}
        />
    );
}
